import { FunctionComponent } from 'react'

import HeaderTopicsSwiper from '../HeaderTopicsSwiper'

const HomeSection: FunctionComponent = () => {
  return <HeaderTopicsSwiper />
}

export default HomeSection
